import { distance2D } from "./ForceDirectedGraph/distance"
import { uniq } from "ramda"
import Point2D from "./ForceDirectedGraph/Point2D"
import { Address, Distance2D } from "./ForceDirectedGraph/types.d"

const NEIGHBORS = [
  { row: 1, col: 0 },
  { row: 2, col: 0 },
  { row: 1, col: -1 },
  { row: -1, col: -1 },
  { row: -2, col: 0 },
  { row: -1, col: 0 },
]

export const getNeighbor = (
  col: number,
  row: number,
  neighborIndex: number,
  THETA_POSITIONS: number,
  PHI_POSITIONS: number
): Address => {
  const neighbor = NEIGHBORS[neighborIndex]

  const newRow = row + neighbor.row
  const newCol = col + neighbor.col

  return {
    row: newRow < 0 ? newRow + PHI_POSITIONS : newRow % PHI_POSITIONS,
    col: newCol < 0 ? newCol + THETA_POSITIONS : newCol % THETA_POSITIONS,
  }
}

export const buildPositionMatrix = (
  THETA_POSITIONS: number,
  PHI_POSITIONS: number
): Point2D[][] => {
  const _THETA_DIVISIONS = 3 * THETA_POSITIONS

  const THETA_INTERVAL = (2 * Math.PI) / _THETA_DIVISIONS
  const PHI_INTERVAL = (2 * Math.PI) / PHI_POSITIONS

  let layer = 0
  const positionMatrix = []

  for (let row = 0; row < PHI_POSITIONS; row++) {
    positionMatrix[row] = Array(THETA_POSITIONS)

    const thetaOffset = layer % 2 === 1 ? 1.5 * THETA_INTERVAL : 0

    for (let col = 0; col < THETA_POSITIONS; col++) {
      positionMatrix[row][col] = new Point2D(
        thetaOffset + 3 * col * THETA_INTERVAL,
        row * PHI_INTERVAL
      )
    }

    layer++
  }

  return positionMatrix
}
/*
export const buildDistanceMatrix = (
  positionMatrix: object[][],
  COL_COUNT,
  ROW_COUNT,
  extents = { x: 2 * Math.PI, y: 2 * Math.PI }
): Distance2D[][][][] => {
  const distances = Array(ROW_COUNT)

  for (let i = 0; i < ROW_COUNT; i++) {
    distances[i] = Array(COL_COUNT)
    for (let j = 0; j < COL_COUNT; j++) {
      distances[i][j] = Array(ROW_COUNT)
      for (let k = 0; k < ROW_COUNT; k++) {
        distances[i][j][k] = Array(COL_COUNT)
        for (let l = 0; l < COL_COUNT; l++) {
          distances[i][j][k][l] = distance2D(
            positionMatrix[i][j],
            positionMatrix[k][l],
            extents
          )
        }
      }
    }
  }

  return distances
}
*/

export const buildEmptyPlacements = (
  THETA_POSITIONS: number,
  PHI_POSITIONS: number
): object[][] => {
  const empties = []

  for (let i = 0; i < PHI_POSITIONS; i++) {
    empties[i] = Array(THETA_POSITIONS)
    for (let j = 0; j < THETA_POSITIONS; j++) {
      empties[i][j] = null
    }
  }

  return empties
}

const getPrecomputedDistance = (
  c1: Address,
  c2: Address,
  distanceMatrix: Distance2D[][][][]
): Distance2D => distanceMatrix[c1.row][c1.col][c2.row][c2.col]

export const assignItemsToNearestAddress = (
  items,
  areaSize,
  addressCoordMatrix,
  THETA_POSITIONS,
  PHI_POSITIONS
) => {
  const placements = buildEmptyPlacements(THETA_POSITIONS, PHI_POSITIONS)

  items.forEach(item => {
    const { position } = item

    let minDistance = { magnitude: Number.MAX_SAFE_INTEGER }
    let closestHexagon = null,
      closestAddress = null

    addressCoordMatrix.forEach((rowArray, row) => {
      rowArray.forEach((coords, col) => {
        if (!placements[row][col]) {
          const distance = distance2D(position, coords, areaSize)

          if (distance.magnitude < minDistance.magnitude) {
            minDistance = distance
            closestHexagon = coords
            closestAddress = { row, col }
          }
        }
      })
    })

    if (closestHexagon) {
      item.position = new Point2D(closestHexagon.x, closestHexagon.y)
      placements[closestAddress.row][closestAddress.col] = item
    }
  })
}
